// extracted by mini-css-extract-plugin
export var container = "Milestones-module--container--0fbaa";
export var introText = "Milestones-module--intro-text--570f2";